import React from "react";
import { TableBody } from "@mui/material";
import { ParentProps } from "../../types";

import "./styles.scss";

const classNameBase = "scd-table-body";

export default function Body(props: ParentProps): React.ReactElement {
  return (
    <TableBody
      classes={{
        root: `${classNameBase}-root`,
      }}
    >
      {props.children}
    </TableBody>
  );
}
